import { createUseStyles } from 'react-jss'

import { mediumGrey } from '../../../../../../styles/const/colors'

const useStyles = createUseStyles(theme => ({
  metricAdditional: {
    color: theme.brandPrimary
  },
  engagementMetricsWrapper: {
    display: 'flex',
    alignItems: 'center',
    columnGap: 4
  },
  engagementItem: {
    display: 'flex',
    alignItems: 'center',
    background: theme.brandPrimary,
    columnGap: 2,
    borderRadius: 17,
    padding: '2px 4px',
    color: 'white',
    lineHeight: '12px',
    '& svg': {
      minWidth: 10,
      maxWidth: 10,
      height: 'auto',
      fill: 'white'
    }
  },
  conversionsWrapper: {
    textAlign: 'right'
  },
  conversionsValue: {
    fontSize: 12,
    color: mediumGrey
  }
}))

export default useStyles
